import Cookies from 'js-cookie'

export default (s = window.settings, langCode) => {
  const userLanguageSelection = 'userLanguageSelection'
  const lc = Cookies.get(userLanguageSelection, langCode)
  let output = 'default' 
    if (langCode) {
      output = langCode;
      Cookies.set(userLanguageSelection, langCode)
    } else if (lc) {
      output = lc
    }
    return output
}
